import {
  IconButton as CIconButton,
  forwardRef,
  useTheme,
} from '@chakra-ui/react';
import { hexToRgbaString } from '~/utils';

const IconButton = forwardRef(({ ...props }, ref) => {
  const theme = useTheme();
  return (
    <CIconButton
      variant="link"
      aria-label="icon-button"
      size="lg"
      minWidth="8"
      minHeight="8"
      _hover={{
        boxShadow: `0 0 10px 0 ${hexToRgbaString(theme.colors.black, 0.2)}`,
      }}
      ref={ref}
      {...props}
    />
  );
});

export default IconButton;
